import type { GoogleAdsStoredConsent } from "@shared/helpers/googleAdsClickId"

const CONSENT_KEYS = [
  "analytics_storage",
  "ad_storage",
  "ad_user_data",
  "ad_personalization",
] as const

function readConsentValue(value: unknown): "granted" | "denied" | undefined {
  if (value === true || value === "granted") return "granted"
  if (value === false || value === "denied") return "denied"
  return undefined
}

/** Only an explicit Consent Mode update. Defaults are not treated as a choice. */
export function readExplicitGoogleConsent(): GoogleAdsStoredConsent | undefined {
  if (typeof window === "undefined") return undefined

  const fromTag: GoogleAdsStoredConsent = {}
  const entries = (window as Window & {
    google_tag_data?: { ics?: { entries?: Record<string, { update?: unknown }> } }
  }).google_tag_data?.ics?.entries
  if (entries) {
    for (const key of CONSENT_KEYS) {
      const parsed = readConsentValue(entries[key]?.update)
      if (parsed) fromTag[key] = parsed
    }
  }
  if (Object.keys(fromTag).length > 0) return fromTag

  const dataLayer = (window as Window & { dataLayer?: unknown }).dataLayer
  if (!Array.isArray(dataLayer)) return undefined
  const fromLayer: GoogleAdsStoredConsent = {}
  for (const entry of dataLayer) {
    if (!Array.isArray(entry) || entry[0] !== "consent" || entry[1] !== "update") {
      continue
    }
    const payload = entry[2]
    if (!payload || typeof payload !== "object") continue
    for (const key of CONSENT_KEYS) {
      const parsed = readConsentValue((payload as Record<string, unknown>)[key])
      if (parsed) fromLayer[key] = parsed
    }
  }
  return Object.keys(fromLayer).length > 0 ? fromLayer : undefined
}
